import type { MotionProps} from 'framer-motion';
import { useReducedMotion } from 'framer-motion';

export const useSafeMotion = (motion: MotionProps): MotionProps => {
  const reduced = useReducedMotion();

  return reduced ? {} : motion;
};
